import React, { useState, useEffect } from 'react';

import { Link } from 'gatsby';

import { useIntl } from '../../../plugins/publicis-gatsby-plugin-i18n';
import Logo from '../../assets/images/logo-text.inline.svg';
import Logo_Without_Text from '../../assets/images/logo.inline.svg';
import NavLink from '../../Molecules/NavLink/NavLink';
import PopinAccessibility from '../PopinAccessibility/PopinAccessibility';
import PopinSearchOnSite from '../PopinSearchOnSite/PopinSearchOnSite';
import BannerHome from './BannerHome/BannerHome';
import BurgerMenu from './BurgerMenu/BurgerMenu';
import HeaderTop from './HeaderTop/HeaderTop';
import SearchHeader from './SearchHeader/SearchHeader';

import './Header.scss';

let classNames = require('classnames');

const Header = ({ mainMenu, latestPublication, latestCommunication, pathname, eventBanner, imagesArray, allDocuments }) => {
  const intl = useIntl();
  const [hoverNavItem, setHoverNavItem] = useState(-1);
  const [openSearchPopin, setOpenSearchPopin] = useState(false);
  let lastScroll = 0;
  const headerMenu = mainMenu;

  const menus = [];
  const footerLegale = [];
  const subMenus = [];

  headerMenu.forEach((item, i) => {
    if (item.node.enabled && !item.node.field_hidden && item.node.menu_name === 'main') {
      if (item.node.drupal_parent_menu_item === null) {
        menus.push({
          title: item.node.title,
          href: item.node.link.url ? item.node.link.url : '/',
          submenus: [],
          id: item.node.drupal_id,
          active: false,
          expanded: item.node?.expanded
        });

        if (menus.length === 3) {
          menus.push({ title: 'logo_elem', href: '/' + item.node.langcode });
        }
      }
      else {
        const parent = item.node.drupal_parent_menu_item;
        const parentID = parent.slice(18);

        subMenus.push({
          title: item.node.title,
          href: item.node.link.url,
          parent: parentID,
          id: item.node.drupal_id,
          active: false
        });
      }
    }
    else if (item.node.enabled && item.node.menu_name === 'footer') {
      footerLegale.push({
        id: i,
        label: item.node.title,
        link: item.node.link.url,
      });
    }
  });

  subMenus.forEach(element => {
    menus.forEach(j => {
      if (element.parent === j.id) {
        j.submenus.push(element);
      }
    });
  });

  menus?.forEach((menu, i) => {
    menu.href === pathname ? menu.active = true :

      menu.submenus?.forEach((m) => {
        if (m.href === pathname) {
          m.active = true;
          menus[i].active = true;
        }
      });
  });

  useEffect(() => {
    window.addEventListener('scroll', showMenuScroll);
    return () => { window.removeEventListener('scroll', showMenuScroll) };
  }, []);

  const showMenuScroll = () => {
    const body = document.body;
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      body.classList.remove('scroll-up', 'scroll-down');
      return;
    }
    if (currentScroll > lastScroll && !body.classList.contains('scroll-down')) {
      // down
      body.classList.remove('scroll-up');
      body.classList.add('scroll-down');
    } else if (
      currentScroll < lastScroll &&
      body.classList.contains('scroll-down')
    ) {
      // up
      body.classList.remove('scroll-down');
      body.classList.add('scroll-up');
    }
    lastScroll = currentScroll;
  };

  const onNavMouseEnter = (i) => {
    setHoverNavItem(i);
  };

  const onClickNavItem = (e, prevent) => {
    if (prevent) {
      e.preventDefault();
    }
  };
  const onKeyDownNavItem = (e, prevent, i) => {
    if (prevent && e.keyCode === 13) {
      e.preventDefault();
      e.currentTarget.setAttribute('aria-expanded', 'true');
      setHoverNavItem(i);
    }
  };

  const onNavMouseLeave = () => {
    setHoverNavItem(-1);
  };

  const onToggleSearchPopin = (isOpen) => {
    setOpenSearchPopin(isOpen);
  };

  return (
    <>
      <header id="header_container" className={classNames('header', { 'header_with_event_banner': eventBanner })} role="banner">
        <div className="header_fix">
          <HeaderTop />
          <div className="header_main">
            <BurgerMenu
              latestCommunication={latestCommunication}
              latestPublication={latestPublication}
              menus={menus}
              footerLegale={footerLegale}
              allDocuments={allDocuments}
            />
            <nav className="nav_main" role="navigation" aria-label={intl.formatMessage({ id: 'ariaLabel.main_menu' })}>
              <ul>
                {menus.map((menu, i) => (
                  <li
                    key={i}
                    className={classNames([
                      menu.expanded ? 'has_sub_menu' : null,
                      menu.title === 'logo_elem' ? 'logo_elem' : null,
                      hoverNavItem === i ? 'hover' : null
                    ])}
                    aria-haspopup={menu.expanded ? 'true' : 'false'}
                  >
                    {menu.title != 'logo_elem' ? (
                      <>
                        <NavLink
                          activeClassName="active"
                          to={menu.href}
                          onMouseEnter={() => onNavMouseEnter(i)}
                          onMouseLeave={onNavMouseLeave}
                          isactive={menu.active.toString()}
                          onClick={e => onClickNavItem(e, menu.expanded ? true : false)}
                          onKeyDown={e => onKeyDownNavItem(e, menu.expanded ? true : false, i)}
                          aria-expanded={hoverNavItem === i ? 'true' : 'false'}
                        >
                          {menu.title}
                        </NavLink>
                        {menu.expanded && menu.submenus && menu.submenus.length > 0 && (
                          <ul
                            className="sub_nav"
                            onMouseEnter={() => onNavMouseEnter(i)}
                            onMouseLeave={onNavMouseLeave}
                          >
                            {menu.submenus.map((submenu, j) => (
                              <li key={`${i}${j}`}>
                                <NavLink
                                  activeClassName="active"
                                  to={submenu.href}
                                  isactive={submenu.active.toString()}
                                >
                                  {submenu.title}
                                </NavLink>
                              </li>

                            ))}
                          </ul>
                        )}
                      </>
                    ) : (
                      <Link
                        to={menu.href}
                        onMouseEnter={() => onNavMouseEnter(i)}
                        onMouseLeave={() => onNavMouseLeave()}
                        title={intl.formatMessage({ id: 'ariaLabel.go_to_homepage' })}
                      >
                        <Logo className="logo logo_text" title={intl.formatMessage({ id: 'ariaLabel.go_to_homepage' })} />
                        <Logo_Without_Text className="logo logo_witout_text" title={intl.formatMessage({ id: 'ariaLabel.go_to_homepage' })} />
                      </Link>
                    )}
                  </li>
                ))}
              </ul>
            </nav>
            <SearchHeader
              openSearchPopin={openSearchPopin}
              onToggleOpenPropsFunc={onToggleSearchPopin}
            />
          </div>
          {eventBanner && <BannerHome imagesArray={imagesArray} />}
        </div>
      </header>
      <PopinAccessibility />
      <PopinSearchOnSite
        openSearchPopin={openSearchPopin}
        onToggleOpenPropsFunc={onToggleSearchPopin}
      />
    </>
  );
};

export default Header;
